import { render, staticRenderFns } from "./v80a1090.vue?vue&type=template&id=0d20eaad&scoped=true"
import script from "./v80a1090.vue?vue&type=script&lang=js"
export * from "./v80a1090.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20eaad",
  null
  
)

export default component.exports